import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/cn';
import { InfoIcon } from 'lucide-react';

export function DescriptionTooltip({
  description,
  className,
}: {
  description?: string;
  className?: string;
}) {
  return (
    <Tooltip>
      <TooltipTrigger
        asChild
        className='ml-2'
        onClick={(e) => e.preventDefault()}
      >
        <InfoIcon className='inline size-[14px] shrink-0 align-text-bottom' />
      </TooltipTrigger>
      <TooltipContent className={cn('max-w-sm', className)}>
        <div className='text-sm text-muted-foreground'>{description}</div>
      </TooltipContent>
    </Tooltip>
  );
}
